import { sbEditable } from '@storyblok/storyblok-editable'
import React, { useContext, useEffect } from 'react'
import { Button } from '../../../components/UI/Button'
import { Tabs } from '../../../components/UI/Tabs'
import { TabsContext } from '../../../components/UI/Tabs/Tabs'

import { useI18n } from '../../../lib/context/i18n'
import CustomLink from '../../../components/CustomLink'
import { TabTeaserItemProps } from './types'
import {
  StyleTabTeaserItemContentElement,
  StyleTabTeaserItemContentWrapper,
  StyleTabTeaserItemHeadline,
  StyleTabTeaserItemImage,
  StyleTabTeaserItemImageWrapper,
  StyleTabTeaserItemProse,
} from './styled'
// import { IconList } from '../../../components/UI/IconList'
import { operationSystems } from '../../../lib/constants'


export const TabTeaserItem = ({ tabId, tab, setTheme }: TabTeaserItemProps) => {
  const { activeTabId } = useContext(TabsContext)
  const { getTranslatedUrlFromLink } = useI18n()
  const isActive = activeTabId === tabId

  const osIcons = operationSystems.map(os => ({ icon: os.content.icon, name: os.content.name }));

  useEffect(() => {
    if (isActive) {
      setTheme(`theme-${tab.theme}` || 'theme-electric-indigo')
    }
  }, [tab.theme, isActive])

  return (
    <Tabs.ContentItem tabId={tabId} {...sbEditable(tab)}>
      <StyleTabTeaserItemContentWrapper>
        <StyleTabTeaserItemContentElement>
          <StyleTabTeaserItemProse>
            <StyleTabTeaserItemHeadline>{tab.headline ? tab.headline : tab.label}</StyleTabTeaserItemHeadline>
            {tab.content && <div className="prose">{tab.content}</div>}
          </StyleTabTeaserItemProse>
          {/* <IconList icons={[...osIcons]} iconSize="1.2rem" /> */}
          {tab.link && tab.link[0] && (
            <Button
              $variant="primary"
              $size="small"
              as={CustomLink}
              $ignoreTheme
              children={<></>}
              title={tab.link[0].text}
              to={getTranslatedUrlFromLink(tab.link[0].link)}
              target={tab.link[0].openInNewTab ? '_blank' : undefined}
            />
          )}
        </StyleTabTeaserItemContentElement>
        <StyleTabTeaserItemImageWrapper>
          {!!tab.image && (
            <StyleTabTeaserItemImage className={isActive ? 'animate' : ''} src={tab.image} alt={tab.label} />
          )}
        </StyleTabTeaserItemImageWrapper>
      </StyleTabTeaserItemContentWrapper>
    </Tabs.ContentItem>
  )
}
